<template>
    <div class="app-sensor water-leak">
        <div class="app-sensor__head">
            <div class="app-sensor__title">{{ item.name }}</div>
            <div class="app-sensor__action">
                <slot name="actionHeader" />
            </div>
        </div>
        <div class="app-sensor__body">
            <div class="app-sensor__description font-weight-light">
                {{ item.description }}
            </div>
            <div class="app-sensor__value">
                {{ value }} <span>м³</span>
            </div>
        </div>
        <div class="app-sensor__chart">
            <SensorStatFlowRelay :id="item.id" />
        </div>
    </div>
</template>
<script>

import SensorStatFlowRelay from './SensorStatFlowRelay'

export default {
    name: 'SensorFlowRelay',
    props: {
        sensor: {
            type: Object,
            default: () => {
                return null
            }
        }
    },
    components: {
        SensorStatFlowRelay
    },
    data: () => ({

    }),
    mounted () {
    },
    watch: {
    },
    methods: {
    },
    computed: {
        item() {
            return this.sensor
        },
        value() {
            return (this.item.value / 1000).toFixed(3)
        }
    },
    created() {   
    },
    unmounted() {
    }
}
</script>